<template>
<div>
  <div class="footer">Copyright © 学说 I 京ICP备20020497号-1</div>
</div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
.footer{
  display: flex;
  justify-content: center;
  align-items: center;
  width:100%;
  height: 100px;
  color:#BFBFBF;
  font-size: 16px;
  background: #000;
  margin-top: 20px;
}
/* pc端样式 */
@media screen and (min-width: 900px) {
}
/* 移动端样式 */
@media screen and (max-width: 900px) {
  .footer{
    font-size: 12px;
  }
}
</style>
